import React from 'react';

import type CompanyProps from '@/types/Company.type';

import Locations from './Locations';
import Overview from './Overview';
import Ventures from './Ventures';

type LeftPanelProps = {
  company: CompanyProps;
};

const LeftPanel = ({ company }: LeftPanelProps) => {
  return (
    <div className="grid grid-cols-1 gap-6">
      <Overview company={company} />
      <Ventures company={company} />
      {company.specific_locations.length && <Locations company={company} />}
    </div>
  );
};

export default LeftPanel;
